import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './CookieConsentBanner.css';

const STORAGE_KEY = 'cookie_consent';

const CookieConsentBanner: React.FC = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  const applyConsent = (accepted: boolean) => {
    const value = accepted ? 'granted' : 'denied';
    // Google Consent Mode v2
    if (typeof (window as any).gtag === 'function') {
      (window as any).gtag('consent', 'update', {
        ad_storage: value,
        analytics_storage: value,
        ad_user_data: value,
        ad_personalization: value,
      });
    }
    localStorage.setItem(STORAGE_KEY, accepted ? 'accepted' : 'refused');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="ccb" role="dialog" aria-modal="true" aria-label={t('cookieConsent.ariaLabel') as string}>
      <div className="ccb__inner">
        <p className="ccb__text">
          {t('cookieConsent.text')}{' '}
          <Link to="/privacy" className="ccb__link">{t('cookieConsent.learnMore')}</Link>
        </p>
        <div className="ccb__actions">
          <button className="ccb__btn ccb__btn--accept" onClick={() => applyConsent(true)}>
            {t('cookieConsent.accept')}
          </button>
          <button className="ccb__btn ccb__btn--refuse" onClick={() => applyConsent(false)}>
            {t('cookieConsent.refuse')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
